// @flow
import { useMemo } from 'react';
import find from 'ramda/es/find';
import propEq from 'ramda/es/propEq';
import head from 'ramda/es/head';
import isEmpty from 'ramda/es/isEmpty';

import type { Klasses, Klass } from 'app/dataTypes/Klasses.types';


export default function useKlassValid(klassId?: string, klasses: Klasses): Klass | null {
  const validKlass = useMemo(() => {
    if (isEmpty(klasses)) {
      return null;
    }
    const byIncomming: Klass | void = klassId ? find(propEq('id', klassId), klasses) : undefined;
    if (byIncomming) {
      return byIncomming;
    }
    const latest: Klass | void = find(propEq('latest', true), klasses);
    if (latest) {
      return latest;
    }
    const defultItem: Klass | void = head(klasses);
    if (defultItem) {
      return defultItem;
    }
    return null;
  }, [klassId, klasses]);

  return validKlass;
}
